import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${Button} {
    padding-right: var(--spacing-02);
  }
`;

interface Props {
  count: number;
  onClearAll: (event) => void;
}

export const AssigneeOptionHeader: FC<Props> = ({ count, onClearAll }) => {
  return (
    <Header>
      <FormattedMessage id="assignees" /> ({count})
      <Button type="link" onClick={onClearAll}>
        <FormattedMessage id="clear_all" />
      </Button>
    </Header>
  );
};
